// Module
var code = "<form> <div class=\"form-group\"> <div class=\"checkbox\"> <label> <input type=\"checkbox\" ng-model=\"$ctrl.disabled\"> Disabled </label> </div> </div> </form> <collabora-online node=\"$ctrl.node\" file=\"$ctrl.file\" ng-disabled=\"$ctrl.disabled\"></collabora-online> ";
// Exports
export default code;